module.exports = __webpack_public_path__ + "img/20191116143905714.acc4f667.jpg";